"use client";

import { useEffect, useRef } from "react";

/** <img> for a File/Blob. The temporary blob: URL is freed when it changes. */
export function BlobImage({
  blob,
  alt,
  className,
  style,
  onError,
}: {
  blob: Blob;
  alt: string;
  className?: string;
  style?: React.CSSProperties;
  onError?: () => void;
}) {
  const ref = useRef<HTMLImageElement>(null);
  useEffect(() => {
    const url = URL.createObjectURL(blob);
    if (ref.current) ref.current.src = url;
    return () => URL.revokeObjectURL(url);
  }, [blob]);
  return (
    // eslint-disable-next-line @next/next/no-img-element -- local blob, not a remote image
    <img
      ref={ref}
      alt={alt}
      className={className}
      style={style}
      onError={onError}
    />
  );
}
